import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/back/api';

export interface User {
    id: string;
    login: string;
    firstname: string;
    lastname: string;
    email: string;
    role: string;
}

export interface LoginResponse {
    message: string;
    token: string;
    user: User;
}

export interface MeResponse {
    user: User;
}

export const authService = {
    login: async (login: string, password: string): Promise<LoginResponse> => {
        const response = await axios.post(`${API_URL}/auth/login.php`, { login, password });
        return response.data;
    },

    getMe: async (token: string): Promise<MeResponse> => {
        const response = await axios.get(`${API_URL}/auth/me.php`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    updateProfile: async (token: string, data: Partial<User> & { phone?: string; address?: string; cp?: string; city?: string }) => {
        const response = await axios.put(`${API_URL}/auth/update_profile.php`, data, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    }
};
